import { render, staticRenderFns } from "./AppReviewDiff.vue?vue&type=template&id=f4613118&scoped=true&"
import script from "./AppReviewDiff.vue?vue&type=script&lang=js&"
export * from "./AppReviewDiff.vue?vue&type=script&lang=js&"
import style0 from "./AppReviewDiff.vue?vue&type=style&index=0&id=f4613118&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4613118",
  null
  
)

export default component.exports